import React, { useContext } from 'react';
import Row from '../../../elements/Row';
import Box from '../../../elements/Box';
import Col from '../../../elements/Col';
import ImageHeader from './ImageHeader';
import Button from '../../../elements/Button';
import { Context } from '@front10/helpers/dist/Context';
import Link from '../../../elements/Link';
import { transformLabel } from './../utils/utils';

const KEY_ENTER = 13;

const ArticleBodyItem = (props) => {
  const {
    article2Subtitle: title,
    article2Author: author,
    images_path,
    article2Items: description,
    article2FooterLink: footerLink,
    article2ImgCredit: imgCredit,
    article2Teaser: teaser,
    article2TeaserImg: teaserImg,
    showOneImage = true,
    showTitle = true,
    showAuthor = true,
    showImage = true,
    showDescription = true,
    showArticleTitle = true,
    showArticleAuthor = true,
    showArticleSubtitle = true,
    showArticleTextDescription = true,
    showFooterLink = false,
    showImgCredit = false,
    showArticleTeaser = false,
    showArticleTeaserImg = false,
    containerSettings,
    articleTitleSettings,
    colArticleSettings,
    informationContainerSettings,
    textDescriptionSettings,
    articleAuthorSettings,
    imageContainerSettings,
    imageSettings,
    textTitleSettings,
    textSubtitleSettings,
    textAuthorSettings,
    footerContainerSettings,
    topButtonSettings,
    scrollIntoViewContent,
    scrollIntoViewSettings,
    dispatch
  } = props;
  const { translate } = useContext(Context);
  const showImageFn = () => {
    if (images_path && images_path.length > 0) {
      return showOneImage ? (
        <ImageHeader image={images_path[0]} focusable={false} {...imageSettings} />
      ) : (
        images_path.map((image) => {
          return (
            <Box {...imageContainerSettings}>
              <ImageHeader image={image} focusable={false} {...imageSettings} />
            </Box>
          );
        })
      );
    }
    return null;
  };

  const wasMakeEnterAction = React.useRef(false);

  const formatValue = (value) => {
    const phoneRex = new RegExp('^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-s./0-9]*$');
    const urlRex = new RegExp(
      // eslint-disable-next-line no-control-regex
      '[(http(s)?)://(www.)?a-zA-Z0-9@:%._+~#=]{2,256}.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)'
    );
    if (!phoneRex.test(value) && !urlRex.test(value)) {
      return transformLabel(value);
    }
    return value;
  };

  const onClickAction = React.useCallback(
    (href, value) => {
      if (!wasMakeEnterAction?.current) {
        dispatch({
          type: 'CLICK_OUT_EVENTS',
          payload: {
            eventType: 'click',
            anchorText: formatValue(value),
            url: href
          }
        });
      }
      wasMakeEnterAction.current = false;
    },
    [dispatch]
  );

  const keyPressAction = React.useCallback(
    (e, href, value) => {
      if (e.keyCode === KEY_ENTER) {
        wasMakeEnterAction.current = true;
        dispatch({
          type: 'CLICK_OUT_EVENTS',
          payload: {
            eventType: 'keypress',
            anchorText: formatValue(value),
            url: href
          }
        });
      }
    },
    [dispatch]
  );

  React.useEffect(() => {
    const links = document.querySelectorAll('a');
    if (links && links.length !== 0) {
      links.forEach((link) => {
        link.onclick = (e) => {
          onClickAction(link.getAttribute('href'), link.textContent);
        };
        link.onkeydown = (e) => {
          keyPressAction(e, link.getAttribute('href'), link.textContent);
        };
      });
    }
  }, [keyPressAction, onClickAction]);

  return (
    <Row width="100%" style={containerSettings}>
      <Col {...colArticleSettings}>
        <Box {...informationContainerSettings}>
          {showTitle && title && (
            <Box {...articleTitleSettings}>
              <span
                className={`fr-article-title`}
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{
                  __html: title
                }}
              />
            </Box>
          )}
          {showAuthor && author && (
            <Box {...articleAuthorSettings}>
              <span
                className={`fr-article-author`}
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{
                  __html: author
                }}
              />
            </Box>
          )}
          {showImage && images_path.length !== 0 && (
            <Box {...imageContainerSettings}>{showImageFn()}</Box>
          )}
          {showImgCredit && imgCredit && (
            <span
              className={`fr-article-img-credit`}
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{
                __html: imgCredit
              }}
            />
          )}
          {showArticleTeaser && teaser && (
            <span
              className={`fr-article-teaser`}
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{
                __html: teaser
              }}
            />
          )}
          {showArticleTeaserImg && teaserImg && (
            <span
              className={`fr-article-teaser-img`}
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{
                __html: teaserImg
              }}
            />
          )}
          {showDescription &&
            description &&
            JSON.parse(description).map(
              ({ textTitle, author, subtitle, textDescription, ...rest }) => {
                return (
                  <>
                    {showArticleTitle && textTitle && (
                      <Box {...textTitleSettings}>
                        <span
                          className={`fr-article-text-title`}
                          // eslint-disable-next-line react/no-danger
                          dangerouslySetInnerHTML={{
                            __html: textTitle
                          }}
                        />
                      </Box>
                    )}
                    {showArticleAuthor && author && (
                      <Box {...textAuthorSettings}>
                        <span
                          className={`fr-article-text-author`}
                          // eslint-disable-next-line react/no-danger
                          dangerouslySetInnerHTML={{
                            __html: author
                          }}
                        />
                      </Box>
                    )}
                    {showArticleSubtitle && subtitle && (
                      <Box {...textSubtitleSettings}>
                        <span
                          className={`fr-article-text-subtitle`}
                          // eslint-disable-next-line react/no-danger
                          dangerouslySetInnerHTML={{
                            __html: subtitle
                          }}
                        />
                      </Box>
                    )}
                    {showArticleTextDescription && textDescription && (
                      <Box {...textDescriptionSettings}>
                        <span
                          className={`fr-article-description`}
                          // eslint-disable-next-line react/no-danger
                          dangerouslySetInnerHTML={{
                            __html: textDescription
                          }}
                        />
                      </Box>
                    )}
                  </>
                );
              }
            )}
        </Box>
        <Box {...footerContainerSettings}>
          {showFooterLink && footerLink && (
            <span
              className={`fr-article-footer`}
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{
                __html: footerLink
              }}
            />
          )}
          {scrollIntoViewSettings.useNativeFunction === false ? (
            <Link
              onClick={(e) => {
                scrollIntoViewContent();
              }}
              href="#tab-list-articles-container"
              className="fr-top-button-article"
              target="_self"
              {...topButtonSettings}
            >
              {translate('cmp-travel-guide-top-button', '[Top]')}
            </Link>
          ) : (
            <Button
              onClick={() => {
                scrollIntoViewContent();
              }}
              className="fr-top-button-article"
              role="link"
              ariaLabel={translate(
                'cmp-travel-guide-top-button-article-a11y',
                'Go to top same page'
              )}
              {...topButtonSettings}
            >
              {translate('cmp-travel-guide-top-button-article', '[Top]')}
            </Button>
          )}
        </Box>
      </Col>
    </Row>
  );
};

export default ArticleBodyItem;
